import { render } from "./noData.vue?vue&type=template&id=0775f78e&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"

import "./noData.vue?vue&type=style&index=0&id=0775f78e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775f78e"]])

export default __exports__